module.exports = __webpack_public_path__ + "media/JackieButlerBlackwellQuote.44dd8268.mp3";